"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { PencilIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import { AuthContext } from "@/components/auth/Auth";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveDropActionsEditProps {
  readonly drop: ExtendedDrop;
  readonly onEdit: () => void;
}
export default function WaveDropActionsEdit(t0) {
  const $ = _c(11);
  const {
    drop,
    onEdit
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  if (connectedProfile?.handle !== drop.author.handle) {
    return null;
  }
  const t1 = `edit-drop-${drop.id}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PencilIcon className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onEdit || $[2] !== t1) {
    t3 = <button type="button" className="tw-text-iron-500 icon tw-px-2 tw-h-full tw-group tw-bg-transparent tw-rounded-full tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-text-[0.8125rem] tw-leading-5 tw-font-medium tw-transition tw-ease-out tw-duration-300" onClick={onEdit} aria-label="Edit" data-tooltip-id={t1}>{t2}</button>;
    $[1] = onEdit;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `edit-drop-${drop.id}`;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    t6 = <span className="tw-text-xs">Edit Message</span>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4) {
    t7 = <Tooltip id={t4} place="top" offset={8} opacity={1} style={t5}>{t6}</Tooltip>;
    $[6] = t4;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[8] = t3;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}